import React from "react"
// import { StaticImage as Img } from "gatsby-plugin-image"
import { ImageRecord, Image as Img } from '../../components/image/image'
import { graphql, useStaticQuery } from "gatsby";

interface MercadolibreImageProps {
    file: 'facturaRapido' | 'interface' | 'sellerInterface' | 'buyerInterface' | 'howToStart' | 'mlLogo';
}

export const MercadolibreImage = ({ file }: MercadolibreImageProps) => {
    const images: ImageRecord = useStaticQuery(graphql`
        {
            facturaRapido: file(relativePath: {eq: "MercadoLibre_Home_Asset.png"}) {
                childImageSharp {
                    gatsbyImageData(width: 900, layout: CONSTRAINED, placeholder: BLURRED)
                }
            }
            interface: file(relativePath: {eq: "Interface.png"}) {
                childImageSharp {
                    gatsbyImageData(width: 900, layout: CONSTRAINED, placeholder: BLURRED)
                }
            }
            sellerInterface: file(relativePath: {eq: "SellerInterface.png"}) {
                childImageSharp {
                    gatsbyImageData(width: 800, layout: CONSTRAINED, placeholder: BLURRED)
                }
            }
            buyerInterface: file(relativePath: {eq: "BuyerInterface.png"}) {
                childImageSharp {
                    gatsbyImageData(width: 800, layout: CONSTRAINED, placeholder: BLURRED)
                }
            }
            howToStart: file(relativePath: {eq: "MercadoLibre_Login_SS.png"}) {
                childImageSharp {
                    gatsbyImageData(width: 800, layout: CONSTRAINED, placeholder: BLURRED)
                }
            }
            mlLogo: file(relativePath: {eq: "mlLogo.png"}) {
                childImageSharp {
                    gatsbyImageData(width: 800, layout: CONSTRAINED, placeholder: BLURRED)
                }
            }
        }
    `)

    if (file === 'facturaRapido') {
        return (
            <Img
                childImageSharp={images[file].childImageSharp.gatsbyImageData}
                alt="Factura Rápido"
            />
        )
    }
    if (file === 'interface') {
        return (
            <Img
                childImageSharp={images[file].childImageSharp.gatsbyImageData}
                alt="Interface"
            />
        )
    }
    if (file === 'sellerInterface') {
        return (
            <Img
                childImageSharp={images[file].childImageSharp.gatsbyImageData}
                alt="Interface"
            />
        )
    }
    if (file === 'buyerInterface') {
        return (
            <Img
                childImageSharp={images[file].childImageSharp.gatsbyImageData}
                alt="Interface"
            />
        )
    }
    if (file === 'howToStart') {
        return (
            <Img
                childImageSharp={images[file].childImageSharp.gatsbyImageData}
                alt="Interface"
            />
        )
    }
    if (file === 'mlLogo') {
        return (
            <Img
                childImageSharp={images[file].childImageSharp.gatsbyImageData}
                alt="Interface"
            />
        )
    }
}